import { Grid, Typography, Card, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Label from "../../../components/Label";
import { TextField, ReferenceField, useRecordContext } from "react-admin";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import { StatusLabel } from "../../../components/Label/status";

const PROJECT_TYPE_LABELS: Record<string, string> = {
  cryptoPayment: "Crypto payment",
  gasStation: "Gas station",
};

// An entity type as read ("Crypto payment"); its code when unknown.
export const projectTypeLabel = (type?: string) => (type ? PROJECT_TYPE_LABELS[type] || type : "");

const YesNoLabel = ({ value }: { value: boolean }) => {
  const { t }: { t: any } = useTranslation();
  return <Label color={value ? "success" : "secondary"}>{value ? t("Yes") : t("No")}</Label>;
};

function InfoProjectTab() {
  const { t }: { t: any } = useTranslation();
  const project = useRecordContext();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box pb={2}>
          <Typography variant="h6">{t("Entity details")}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t("Identity, account and settings of this entity")}
          </Typography>
        </Box>
        <AnimatedBlock>
          <Card>
            <Box px={2} py={1}>
              <InfoRow label={t("ID")}>
                <TextField source="id" sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 400 }} />
              </InfoRow>
              <InfoRow label={t("Code")}>
                <TextField source="codeProject" sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 400 }} />
              </InfoRow>
              <InfoRow label={t("Name")}>{project.name}</InfoRow>
              <InfoRow label={t("Account")}>
                <ReferenceField source="accountId" reference="accounts">
                  <TextField source="name" sx={{ fontWeight: 700 }} />
                </ReferenceField>
              </InfoRow>
              <InfoRow label={t("Type")}>{t(projectTypeLabel(project.typeProject))}</InfoRow>
              {project.typeProject !== "gasStation" && (
                <>
                  <InfoRow label={t("Auto conversion")}>
                    <YesNoLabel value={Boolean(project.autoConvert)} />
                  </InfoRow>
                  <InfoRow label={t("Fees included")}>
                    <YesNoLabel value={Boolean(project.feesIncluded)} />
                  </InfoRow>
                </>
              )}
              <InfoRow label={t("Status")}>
                <StatusLabel fontSize="small" statusField="status" />
              </InfoRow>
            </Box>
          </Card>
        </AnimatedBlock>
      </Grid>
    </Grid>
  );
}

export default InfoProjectTab;
